import { render, staticRenderFns } from "./FormFieldsCard.vue?vue&type=template&id=bc058950&"
import script from "./FormFieldsCard.vue?vue&type=script&lang=js&"
export * from "./FormFieldsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports